/**
 * This file contains supported layouts and maps layout names to their component.
 */

import logJsUnexpected from '@zr/utilities/telemetry/logJsUnexpected';

import ScreenModal from './Layouts/ScreenModal';

// each supported layout, which should be set by applyParameters.layout when starting a flow
export const MODAL = 'screen_modal';

// for prop types
export const SUPPORTED_LAYOUTS = [MODAL];

export const layoutComponentMap = {
  [MODAL]: ScreenModal,
};

export function getLayoutComponent(layout) {
  let LayoutComponent = layoutComponentMap[layout];

  // this means we received a layout that doesn't exist, log that this happened
  if (!LayoutComponent) {
    LayoutComponent = ScreenModal;
    logJsUnexpected(`Invalid screen layout received: ${layout}`);
  }

  return LayoutComponent;
}
